import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RadioInputComponent} from './radio-input.component';
import {TranslocoModule} from '@ngneat/transloco';
import {FormsModule} from '@angular/forms';
import {OptionButtonsModule} from '@shared/controls/option-buttons/option-buttons.module';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons';
import {IneligibilityOverlayModule} from '@blocks/input/ineligibility-overlay/ineligibility-overlay.module';
import {FontSizeModule} from '@shared/directives/font-size/font-size.module';
import {SubmissionGizmoModule} from '@shared/submission-gizmo/submission-gizmo.module';
import {RequiredIndicatorComponent} from '@shared/controls/required-indicator/required-indicator.component';
import {ReadonlyIndicatorComponent} from '@shared/controls/readonly-indicator/readonly-indicator.component';

@NgModule({
  declarations: [
    RadioInputComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    FormsModule,
    OptionButtonsModule,
    FontAwesomeModule,
    IneligibilityOverlayModule,
    FontSizeModule,
    SubmissionGizmoModule,
    RequiredIndicatorComponent,
    ReadonlyIndicatorComponent
  ],
  exports: [
    RadioInputComponent
  ]
})
export class RadioInputModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faChevronDown);
  }
}
